import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4991e56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative","overflow":"hidden","background-color":"#050722"} }
const _hoisted_2 = { class: "navigator" }
const _hoisted_3 = { class: "navigator-head" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"justify-content":"flex-start","color":"#dcfafa"} }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"justify-content":"center","font-size":"1rem","font-weight":"600","font-style":"italic"} }, "KRI DIGITALIZE", -1))
const _hoisted_6 = { style: {"justify-content":"flex-end"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#4d9fff","display":"flex","justify-content":"center","align-items":"center","font-size":"0.7rem","height":"1.6rem"} }, " 零售业务部 ", -1))
const _hoisted_8 = { class: "left-part" }
const _hoisted_9 = { class: "panel-title" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("零售业务部风险定级")
const _hoisted_12 = { class: "risk-grade-head" }
const _hoisted_13 = { class: "risk-grade-title" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "risk-grade-body" }
const _hoisted_16 = { class: "panel-title" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-between","padding":"0.2rem 0rem 0.2rem 0.6rem"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"3.2rem"} }, "模块名称", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("得分 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("权重 ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("风险等级 ")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"2rem"} }, "趋势", -1))
const _hoisted_24 = {
  key: 1,
  style: {"display":"flex","justify-content":"space-between","padding":"0.2rem 0rem 0.2rem 0.6rem"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"3.2rem"} }, "大区名称", -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("得分 ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("风险等级 ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"2rem"} }, "趋势", -1))
const _hoisted_29 = {
  key: 2,
  class: "risk-grade-body card-list",
  style: {"height":"10rem","overflow-y":"auto"}
}
const _hoisted_30 = ["title"]
const _hoisted_31 = { style: {"width":"1.8rem"} }
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 3,
  class: "risk-grade-body card-list",
  style: {"height":"10rem","overflow-y":"auto"}
}
const _hoisted_34 = ["title"]
const _hoisted_35 = { style: {"width":"1.2rem"} }
const _hoisted_36 = { style: {"width":"1.8rem"} }
const _hoisted_37 = { style: {"width":"1.8rem"} }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "right-part" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-title" }, "风险定级说明", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "year-on-year" }, "1级风险最高，5级风险最低")
  ])
], -1))
const _hoisted_42 = { class: "risk-grade-body" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "risk-grade-bar" }, null, -1))
const _hoisted_44 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_45 = { style: {"color":"#dcfafa"} }

import * as echarts from 'echarts';
import { computed, reactive, ref } from 'vue';
import stubs from '@/init';

// 组件
import Panel from './views/Panel.vue';
import RegionDetail from './views/RegionDetail.vue';
import VChart from 'vue-echarts';
import RadarOrBarChart from './views/RadarOrBarChart.vue';

// controller
import CockpitController from './controller/Cockpit.Controller';
import CockpitRetailBusinessController from './controller/CockpitRetailBusiness.Controller';
import { SimpleItem } from '@velites/common/src';
import { RegionSimpleVO, RetailBusinessVO } from './vo';
import { gradeToDescription, hexToRgba } from '@/utils/utilsHandle';
import { gradeColor, markImage, provinceKeyToName } from './constant';
import { params } from './common';

// 初始化 ECharts 实例

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const cockpitController: CockpitController =
  stubs.injector.get(CockpitController);
const cockpitRetailBusinessController: CockpitRetailBusinessController =
  stubs.injector.get(CockpitRetailBusinessController);

const regionDetail = ref(null as any);

const state = reactive({
  options: [] as SimpleItem[],
  year: '',
  retailBusiness: {} as RetailBusinessVO,
  detailPanelPosition: {
    top: '0px',
    left: '0px',
  },
  mode: 'region' as 'region' | 'module',
  moduleOrder: {
    field: '',
    asc: true,
  },
  regionOrder: {
    field: '',
    asc: true,
  },
});

const moduleList = computed(() => {
  const list = [...(state.retailBusiness?.moduleList || [])];
  const field = state.moduleOrder.field;
  if (field) {
    list.sort(
      (a: any, b: any) =>
        (a[field] > b[field] ? 1 : -1) * (state.moduleOrder.asc ? 1 : -1)
    );
  }
  return list;
});

const regionList = computed(() => {
  const list = [...(state.retailBusiness?.regionList || [])];
  const field = state.regionOrder.field;
  if (field) {
    list.sort(
      (a: any, b: any) =>
        (a[field] > b[field] ? 1 : -1) * (state.regionOrder.asc ? 1 : -1)
    );
  }
  return list;
});

// 配置项
const option = reactive({
  backgroundColor: '#050722',
  series: [] as any[],
});

// methods

const changeModuleOrder = (field: string) => {
  if (state.moduleOrder.field !== field) {
    state.moduleOrder.field = field;
    state.moduleOrder.asc = true;
  } else if (!state.moduleOrder.asc) {
    state.moduleOrder.field = '';
  } else {
    state.moduleOrder.asc = false;
  }
};

const changeRegionOrder = (field: string) => {
  if (state.regionOrder.field !== field) {
    state.regionOrder.field = field;
    state.regionOrder.asc = true;
  } else if (!state.regionOrder.asc) {
    state.regionOrder.field = '';
  } else {
    state.regionOrder.asc = false;
  }
};

const registerMap = (regionCodes: Array<string>, mapName: string) => {
  try {
    const json = regionCodes
      .map((code) => require(`@/assets/map/map_data/${code}_full.json`))
      .reduce((prev, cur) => {
        prev.features = prev.features.concat(cur.features);
        return prev;
      });
    echarts.registerMap(mapName, json);
  } catch (err) {
    console.log(err);
  }
};

const multiple100 = (num: number | null | undefined) => {
  if (typeof num === 'number') return num * 100 + '%';
  return num;
};

const setMap = (regions: RegionSimpleVO[]) => {
  registerMap(['100000'], 'china');
  option.series = [
    {
      roam: true,
      scaleLimit: {
        // 限制地图缩放范围
        min: 1,
        max: 3,
      },
      type: 'map',
      map: 'china',
      selectedMode: false,
      label: {
        show: true,
        color: '#050722',
      },
      // selectedMode: false,
      emphasis: {
        label: {
          show: true,
          color: '#050722',
        },
        itemStyle: {
          // 更改地图背景色和边界颜色
          areaColor: '#050722',
          borderColor: '#159aff',
        },
      },
      center: [105, 35],
      itemStyle: {
        // 更改地图背景色和边界颜色
        areaColor: '#050722',
        borderColor: '#159aff',
      },
      zoom: 2.0,
      regions: [],
      nameMap: {},
      markPoint: {
        data: regions.map((region) => ({
          name: region.name,
          region: region,
          coord: [region.longitude, region.latitude],
          symbol: 'image://' + markImage[region.level], // 标记点的图标类型
          symbolSize: [30, 35], // 标记点的大小
          label: {
            show: true,
            formatter: '{b}',
            position: 'top',
            color: 'white', // 设置标记点字体颜色为白色
          },
        })),
      },
    },
  ];
};

const showMap = (event: any) => {
  if (
    event.componentType === 'markPoint' &&
    typeof regionDetail.value?.active === 'function'
  ) {
    const region = event.data.region;
    state.detailPanelPosition = {
      top: event.event.offsetY + 'px',
      left: event.event.offsetX + 'px',
    };
    regionDetail.value.active(region);
    const areaColor = hexToRgba(gradeColor[region.level], 0.3);
    option.series[0].data = region.scope
      .map((code: string) => provinceKeyToName[code])
      .map((name: string) => ({
        name,
        label: {
          show: true,
          color: '#050722',
        },
        itemStyle: { areaColor },
        emphasis: {
          itemStyle: { areaColor },
          label: {
            show: true,
            color: '#050722',
          },
        },
      }));
  } else {
    regionDetail.value.hide();
  }
};

const selectYear = async (year: string) => {
  params.year = year;
  state.retailBusiness = await cockpitRetailBusinessController.retailBusiness(
    year
  );
  setMap(state.retailBusiness.regionList);
};

const init = async () => {
  const years = await cockpitController.year();
  state.options = years.map((it) => ({
    label: it.year + '',
    value: it.year + '',
  }));
  if (params.year) {
    selectYear(params.year);
  } else if (state.options.length) {
    selectYear(state.options[0].value as string);
  }
};

init();

expose({
  init,
});

return (_ctx: any,_cache: any) => {
  const _component_simple_select = _resolveComponent("simple-select")!
  const _component_CaretTop = _resolveComponent("CaretTop")!
  const _component_CaretBottom = _resolveComponent("CaretBottom")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VChart), {
      option: _unref(option),
      onMouseover: showMap,
      autoresize: true,
      style: {"width":"100%","height":"calc(100vh)","min-width":"800px"}
    }, null, 8, ["option"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_simple_select, {
            style: {"width":"5rem"},
            options: _unref(state).options,
            modelValue: _unref(params).year,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(params).year) = $event)),
            onChange: selectYear
          }, null, 8, ["options", "modelValue"])
        ])
      ]),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(Panel, { style: {"padding":"0.8rem","margin-bottom":"0.8rem"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: require('@/assets/images/home/earth.png')
            }, null, 8, _hoisted_10),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_13, [
                _createElementVNode("span", null, [
                  _createElementVNode("img", {
                    style: {"width":"20px","height":"20px","margin-right":"6px","position":"relative","top":"2px"},
                    src: 
                    require(`@/assets/images/home/grade-${_unref(state).retailBusiness.level}.png`)
                  
                  }, null, 8, _hoisted_14)
                ]),
                _createTextVNode(_toDisplayString(_unref(state).retailBusiness.level), 1)
              ]),
              _createElementVNode("span", null, _toDisplayString(_unref(state).retailBusiness.value || '-'), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["year-on-year", { red: _unref(state).retailBusiness.trendLevel < 0 }])
              }, _toDisplayString(_unref(gradeToDescription)(_unref(state).retailBusiness.trendLevel || 0)), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(RadarOrBarChart, {
              categories: 
              (_unref(state).retailBusiness.moduleList || []).map((it) => it.name)
            ,
              values: [
              (_unref(state).retailBusiness.moduleList || []).map((it) => it.level),
            ]
            }, null, 8, ["categories", "values"])
          ])
        ]),
        _: 1
      }),
      _createVNode(Panel, { style: {"padding":"0.8rem"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("img", {
              src: require('@/assets/images/home/earth.png')
            }, null, 8, _hoisted_17),
            _createElementVNode("span", {
              style: _normalizeStyle([{"margin-right":"0.5rem","cursor":"pointer"}, {
              color: _unref(state).mode === 'region' ? 'rgb(16, 111, 218)' : '',
            }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).mode = 'region'))
            }, "大区情况", 4),
            _createElementVNode("span", {
              style: _normalizeStyle([{"cursor":"pointer"}, {
              color: _unref(state).mode === 'module' ? 'rgb(16, 111, 218)' : '',
            }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).mode = 'module'))
            }, "模块情况", 4)
          ]),
          (_unref(state).mode === 'module')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", {
                  style: {"width":"1.4rem","cursor":"pointer"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (changeModuleOrder('value')))
                }, [
                  _hoisted_20,
                  (_unref(state).moduleOrder.field === 'value')
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                        default: _withCtx(() => [
                          (_unref(state).moduleOrder.asc)
                            ? (_openBlock(), _createBlock(_component_CaretTop, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_CaretBottom, { key: 1 }))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  style: {"width":"1.4rem","cursor":"pointer"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (changeModuleOrder('weight')))
                }, [
                  _hoisted_21,
                  (_unref(state).moduleOrder.field === 'weight')
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                        default: _withCtx(() => [
                          (_unref(state).moduleOrder.asc)
                            ? (_openBlock(), _createBlock(_component_CaretTop, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_CaretBottom, { key: 1 }))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  style: {"width":"2.2rem","cursor":"pointer"},
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (changeModuleOrder('level')))
                }, [
                  _hoisted_22,
                  (_unref(state).moduleOrder.field === 'level')
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                        default: _withCtx(() => [
                          (_unref(state).moduleOrder.asc)
                            ? (_openBlock(), _createBlock(_component_CaretTop, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_CaretBottom, { key: 1 }))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_23
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", {
                  style: {"width":"1.4rem","cursor":"pointer"},
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (changeRegionOrder('value')))
                }, [
                  _hoisted_26,
                  (_unref(state).regionOrder.field === 'value')
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                        default: _withCtx(() => [
                          (_unref(state).regionOrder.asc)
                            ? (_openBlock(), _createBlock(_component_CaretTop, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_CaretBottom, { key: 1 }))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  style: {"width":"2.2rem","cursor":"pointer"},
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (changeRegionOrder('level')))
                }, [
                  _hoisted_27,
                  (_unref(state).regionOrder.field === 'level')
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                        default: _withCtx(() => [
                          (_unref(state).regionOrder.asc)
                            ? (_openBlock(), _createBlock(_component_CaretTop, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_CaretBottom, { key: 1 }))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_28
              ])),
          (_unref(state).mode === 'region')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(regionList), (subsidiary) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: subsidiary.id,
                    class: "region-card"
                  }, [
                    _createElementVNode("div", {
                      style: {"white-space":"nowrap","overflow-x":"hidden","overflow-y":"hidden","text-overflow":"ellipsis","width":"3rem"},
                      title: subsidiary.name
                    }, _toDisplayString(subsidiary.name), 9, _hoisted_30),
                    _createElementVNode("div", _hoisted_31, _toDisplayString(subsidiary.value), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, [
                        _createElementVNode("img", {
                          style: {"width":"0.5rem","height":"0.5rem"},
                          src: 
                    require(`@/assets/images/home/grade-${
                      subsidiary.level || 1
                    }.png`)
                  
                        }, null, 8, _hoisted_32)
                      ]),
                      _createTextVNode(_toDisplayString(subsidiary.level), 1)
                    ]),
                    _createElementVNode("div", {
                      style: {"width":"1.8rem","text-align":"center"},
                      class: _normalizeClass(["year-on-year", { red: subsidiary.trendLevel < 0 }])
                    }, _toDisplayString(_unref(gradeToDescription)(subsidiary.trendLevel || 0)), 3)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(moduleList), (subsidiary) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: subsidiary.id,
                    class: "region-card"
                  }, [
                    _createElementVNode("div", {
                      style: {"white-space":"nowrap","overflow-x":"hidden","overflow-y":"hidden","text-overflow":"ellipsis","width":"3.2rem"},
                      title: subsidiary.name
                    }, _toDisplayString(subsidiary.name), 9, _hoisted_34),
                    _createElementVNode("div", _hoisted_35, _toDisplayString(subsidiary.value), 1),
                    _createElementVNode("div", _hoisted_36, _toDisplayString(multiple100(subsidiary.weight)), 1),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("span", null, [
                        _createElementVNode("img", {
                          style: {"width":"0.5rem","height":"0.5rem"},
                          src: 
                    require(`@/assets/images/home/grade-${
                      subsidiary.level || 1
                    }.png`)
                  
                        }, null, 8, _hoisted_38)
                      ]),
                      _createTextVNode(_toDisplayString(subsidiary.level), 1)
                    ]),
                    _createElementVNode("div", {
                      style: {"width":"1.8rem","text-align":"center"},
                      class: _normalizeClass(["year-on-year", { red: subsidiary.trendLevel < 0 }])
                    }, _toDisplayString(_unref(gradeToDescription)(subsidiary.trendLevel || 0)), 3)
                  ]))
                }), 128))
              ]))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createVNode(Panel, {
        style: {"margin-bottom":"15px","padding":"10px 20px"},
        "border-color": "transparent"
      }, {
        default: _withCtx(() => [
          _hoisted_40,
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 4, 3, 2, 1], (item) => {
                return _createElementVNode("span", _hoisted_45, _toDisplayString(item) + "级", 1)
              }), 64))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: "anywhere-part",
      style: _normalizeStyle({
        top: _unref(state).detailPanelPosition.top,
        left: _unref(state).detailPanelPosition.left,
      })
    }, [
      _createVNode(RegionDetail, {
        ref_key: "regionDetail",
        ref: regionDetail,
        year: _unref(params).year
      }, null, 8, ["year"])
    ], 4)
  ]))
}
}

})